import {NatGetRoomToResident} from './NatGetRoomToResident'
import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'
import {NatPostRoomToResident} from './NatPostRoomToResident'
import {NatPostRoomToResidentImport} from './NatPostRoomToResidentImport'
import {NatGetRoomToResidentAuthenticationKey} from './NatGetRoomToResidentAuthenticationKey'
import {NatPutRoomToResident, NatPutRoomToResidentParams} from './NatPutRoomToResident'
import {NatGetRoomToResidentDetails} from './NatGetRoomToResidentDetails'
import {NatPutRoomToResidentActivation, NatPutRoomToResidentActivationParams} from './NatPutRoomToResidentActivation'
import {isNull} from '../../../common/util/Natutil'
import {DeleteRoomToResidentRequest, NatDeleteRoomToResident} from './NatDeleteRoomToResident'
import {
    NatPutNonPersonalInfoRoomToResident,
    NatPutNonPersonalInfoRoomToResidentParams,
} from './NatPutNonPersonalInfoRoomToResident'
import {
    NatPutRoomToResidentNoticeApplyPermit,
    NatPutRoomToResidentNoticeApplyPermitParams,
} from './NatPutRoomToResidentNoticeApplyPermit'
import {NatPutRoomToResidentNoticeApply, NatPutRoomToResidentNoticeApplyParams} from './NatPutRoomToResidentNoticeApply'
import {NatGetRoomToResidentAuthKeyNoticeData} from './NatGetRoomToResidentAuthKeyNoticeData'
import {
    NatPutRoomToResidentNoticeIssueDone,
    NatPutRoomToResidentNoticeIssueDoneParams,
} from './NatPutRoomToResidentNoticeIssueDone'
import {NatPutResidentUserImport} from './NatPutResidentUserImport'
import {formatDateLocal} from '../../../../formatters/formatMoment'
import {Nullable} from '../../../../app/TypeHelpers'
import moment from 'moment'
import {NatGetRegistrationApplyListRequest, NatGetRegistrationApplyListResponse} from './NatGetRegistrationApplyList'
import {NatGetRegistrationApplyResponse} from './NatGetRegistrationApply'
import {
    NatPostRegistrationApplyApproveRequest,
    NatPostRegistrationApplyApproveResponse,
} from './NatPostRegistrationApplyApprove'
import {
    NatPostResidentUserRegistrationApplyRequest,
    NatPostResidentUserRegistrationApplyResponse,
} from './NatPostResidentUserRegistrationApply'
import {
    NatPutResidentUserRegistrationApplyRequest,
    NatPutResidentUserRegistrationApplyResponse,
} from './NatPutResidentUserRegistrationApply'
import {
    NatPutRegistrationApplyRemandRequest,
    NatPutRegistrationApplyRemandResponse,
} from './NatPutRegistrationApplyRemand'
import {NatDeleteRegistrationApplyRequest, NatDeleteRegistrationApplyResponse} from './NatDeleteRegistrationApply'
import {
    NatPutRoomToResidentAbolitionReset,
    NatPutRoomToResidentAbolitionResetParams,
} from './NatPutRoomToResidentAbolitionReset'
import {
    NatGetResidentUserStatusListRequest,
    NatGetResidentUserStatusListResponse,
} from './NatGetResidentUserStatusConfirmation'
import {NatGetResidentAuthKeyNoticeApplyResponse} from './NatGetResidentAuthKeyNoticeApply'
import {
    NatPutResidentNoticeApplyRejection,
    NatPutResidentNoticeApplyRejectionParams
} from './NatPutResidentNoticeApplyRejection'

export interface RegisterRoomToResidentParams {
    condominiumCd: string
    ridgeCd: string
    roomNumber: string
    roleId: string
    cardKeyNumber: string
    adminFamilyName: string
    adminFirstName: string
    adminFamilyNameKana: string
    adminFirstNameKana: string
    validPeriodStartDate: string
    validPeriodEndDate: string
    memo: string
}

export interface GetRoomToResidentParams {
    ridgeCd?: string
    roomNumber?: string
    roleId?: string
    familyName?: string
    firstName?: string
    familyNameKana?: string
    firstNameKana?: string
    mailAddress?: string
    status?: string
    condominiumGroupId?: string
    condominiumCd?: string
    condominiumName?: string
    mainUserFlag?: number
    cardKeyNumberIsNotNullFlg?: number
    excludeResidentUserInfo?: string[]
    validPeriodCriteriaDate?: Nullable<moment.Moment>
    sortInfo?: string[]
}


export interface RegisterRoomToResidentImportParams {
    condominiumCd: string
    residentUserBulkRegistrationData: string | ArrayBuffer | null
}

export interface PutRoomToResidentParams {
    seq: number
    abolitionDatetimeUpdateFlag: boolean
}

export default class NatRoomToResidentRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    // 部屋居住者取得
    async getRoomToResidentDetails(condominiumCd: string, ridgeCd: string, roomNumber: string, seq: string):
        Promise<NatGetRoomToResidentDetails> {
        return await this.http.get(`/api/admin/roomToResident/${condominiumCd}/${ridgeCd}/${roomNumber}/${seq}`)
    }

    // 部屋居住者取得（認証キー）
    async getRoomToResidentByAuthenticationKey(authenticationKey: string):
        Promise<NatGetRoomToResidentAuthenticationKey> {
        return await this.http.get(`/api/resident/roomToResident/authenticationKey/${isNull(authenticationKey)}`)
    }

    // 部屋居住者登録
    async postRoomToResiden(requestParams: RegisterRoomToResidentParams): Promise<NatPostRoomToResident> {
        return await this.http.post(`/api/admin/roomToResident`, {
                condominiumCd: requestParams.condominiumCd,
                ridgeCd: requestParams.ridgeCd,
                roomNumber: requestParams.roomNumber,
                roleId: requestParams.roleId,
                cardKeyNumber: requestParams.cardKeyNumber,
                adminFamilyName: requestParams.adminFamilyName,
                adminFirstName: requestParams.adminFirstName,
                adminFamilyNameKana: requestParams.adminFamilyNameKana,
                adminFirstNameKana: requestParams.adminFirstNameKana,
                validPeriodStartDate: requestParams.validPeriodStartDate,
                validPeriodEndDate: requestParams.validPeriodEndDate,
                memo: requestParams.memo,
            }, ContentType.JSON,
        )
    }

    // 部屋居住者登録
    async postRoomToResidenImport(requestParams: RegisterRoomToResidentImportParams):
        Promise<NatPostRoomToResidentImport> {
        return await this.http.post(`/api/admin/roomToResident/import`, {
                condominiumCd: requestParams.condominiumCd,
                residentUserBulkRegistrationData: requestParams.residentUserBulkRegistrationData,
            }, ContentType.JSON,
        )
    }

    // 部屋居住者一括更新
    async putRoomToResidentImport(
        condominiumCd: string,
        residentUserBulkUpdationData: string | ArrayBuffer | null,
    ): Promise<NatPutResidentUserImport> {
        return await this.http.put(`/api/admin/roomToResident/import`, {
            condominiumCd: condominiumCd,
            residentUserBulkUpdationData: residentUserBulkUpdationData,
        })
    }

    // 部屋居住者廃止取消
    async putRoomToResidentAbolitionReset(requestParam: NatPutRoomToResidentAbolitionResetParams):
        Promise<NatPutRoomToResidentAbolitionReset> {
        return await this.http.put(`/api/admin/roomToResident/abolitionReset`, requestParam)
    }

    // 部屋居住者一覧取得
    async getRoomToResident(
        searchCondition: GetRoomToResidentParams,
    ): Promise<NatGetRoomToResident> {
        let validPeriodCriteriaDate: Nullable<string>
        if (searchCondition.validPeriodCriteriaDate === undefined ||
            searchCondition.validPeriodCriteriaDate === null) {
            validPeriodCriteriaDate = null
        } else {
            validPeriodCriteriaDate = formatDateLocal(searchCondition.validPeriodCriteriaDate)
        }
        return await this.http.post(
            '/api/admin/roomToResidentList',
            {
                ridgeCd: searchCondition.ridgeCd === '' ? null : searchCondition.ridgeCd,
                roomNumber: searchCondition.roomNumber === '' ? null : searchCondition.roomNumber,
                roleId: searchCondition.roleId === '' ? null : searchCondition.roleId,
                familyName: searchCondition.familyName === '' ? null : searchCondition.familyName,
                firstName: searchCondition.firstName === '' ? null : searchCondition.firstName,
                familyNameKana: searchCondition.familyNameKana === '' ? null : searchCondition.familyNameKana,
                firstNameKana: searchCondition.firstNameKana === '' ? null : searchCondition.firstNameKana,
                mailAddress: searchCondition.mailAddress === '' ? null : searchCondition.mailAddress,
                status: searchCondition.status === '' ? null : searchCondition.status,
                condominiumGroupId:
                    searchCondition.condominiumGroupId === '' ? null : searchCondition.condominiumGroupId,
                condominiumCd: searchCondition.condominiumCd === '' ? null : searchCondition.condominiumCd,
                condominiumName: searchCondition.condominiumName === '' ? null : searchCondition.condominiumName,
                mainUserFlag: searchCondition.mainUserFlag,
                cardKeyNumberIsNotNullFlag: searchCondition.cardKeyNumberIsNotNullFlg,
                excludeResidentUserInfo: searchCondition.excludeResidentUserInfo,
                validPeriodCriteriaDate: validPeriodCriteriaDate,
                sortInfo: searchCondition.sortInfo,
            },
            ContentType.JSON,
        )
    }

    // 部屋居住者更新
    async putRoomToResiden(requestParam: PutRoomToResidentParams): Promise<void> {
        return await this.http.put(`/api/resident/roomToResident`, requestParam)
    }

    // 部屋居住者削除
    async deleteRoomToResidentByResident(seq: number): Promise<void> {
        return await this.http.delete(`/api/resident/roomToResident/${seq}`)
    }


    // 部屋居住者削除（管理）
    async deleteRoomToResident(request: DeleteRoomToResidentRequest):
        Promise<NatDeleteRoomToResident> {
        let queryString: string = `${request.condominiumCd}/${request.ridgeCd}/${request.roomNumber}/${request.seq}`
        const params: string[] = []
        if (request.permissionWarning) {
            request.permissionWarning.forEach((permissionMessage) => {
                params.push('permissionWarning=' + permissionMessage.messageId)
            })
        }
        if (params.length !== 0) {
            queryString = `${queryString}?${params.join('&')}`
        }

        return await this.http.delete(
            `/api/admin/roomToResident/delete/${queryString}`)
    }

    // 部屋居住者更新（管理）
    async putRoomToResidentForAdmin(requestParam: NatPutRoomToResidentParams): Promise<NatPutRoomToResident> {
        return await this.http.put(`/api/admin/roomToResident`, requestParam)
    }

    // 部屋居住者更新（非個人情報）（管理）
    async putNonPersonalInfoRoomToResidentForAdmin(requestParam: NatPutNonPersonalInfoRoomToResidentParams):
        Promise<NatPutNonPersonalInfoRoomToResident> {
        return await this.http.put(`/api/admin/roomToResident/nonPersonalInfo`, requestParam)
    }

    // 部屋居住者更新（管理）
    async putRoomToResidentActivation(requestParam: NatPutRoomToResidentActivationParams):
        Promise<NatPutRoomToResidentActivation> {
        return await this.http.put(`/api/admin/roomToResident/activation`, requestParam)
    }

    // 通知状発行申請許可
    async putRoomToResidentNoticeApplyPermit(requestParam: NatPutRoomToResidentNoticeApplyPermitParams):
        Promise<NatPutRoomToResidentNoticeApplyPermit> {
        return await this.http.put(`/api/admin/roomToResident/noticeApplyPermit`, requestParam)
    }

    // 通知状発行申請
    async putRoomToResidentNoticeApply(requestParam: NatPutRoomToResidentNoticeApplyParams):
        Promise<NatPutRoomToResidentNoticeApply> {
        return await this.http.put(`/api/admin/roomToResident/noticeApply`, requestParam)
    }

    // 認証キー通知状データ取得
    async getAuthKeyNoticeData(condominiumCd: string, ridgeCd: string, roomNumber: string, seq: string):
        Promise<NatGetRoomToResidentAuthKeyNoticeData> {
        return await this.http.get(`/api/admin/roomToResident/authKeyNotice/${condominiumCd}/${ridgeCd}/${roomNumber}/${seq}`)
    }

    // 認証キー通知状発行完了
    async putAuthKeyNoticeIssueDone(requestParam: NatPutRoomToResidentNoticeIssueDoneParams):
        Promise<NatPutRoomToResidentNoticeIssueDone> {
        return await this.http.put(`/api/admin/roomToResident/authKeyNoticeIssueDone`, requestParam)
    }

    // 部屋居住者登録申請一覧
    async getResidentUserApplyList(request: NatGetRegistrationApplyListRequest):
        Promise<NatGetRegistrationApplyListResponse> {
        const sortInfos: string[] = []
        request.sortInfo.forEach((sortInfo) => {
            sortInfos.push(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
        })

        return await this.http.post(
            '/api/admin/roomToResident/registrationApplyList',
            {
                ridgeCd: request.ridgeCd === '' ? null : request.ridgeCd,
                roomNumber: request.roomNumber === '' ? null : request.roomNumber,
                status: request.status.length === 0 ? null : request.status.join(','),
                condominiumGroupId: request.condominiumGroupId === null ? null : request.condominiumGroupId,
                condominiumCd: request.condominiumCd === '' ? null : request.condominiumCd,
                condominiumName: request.condominiumName === '' ? null : request.condominiumName,
                applyStartDate: request.applyStartDate === '' ? null : request.applyStartDate,
                applyEndDate: request.applyEndDate === '' ? null : request.applyEndDate,
                pageNum: request.pageNum,
                page: request.page,
                sortInfo: sortInfos,
            },
            ContentType.JSON,
        )
    }

    // 部屋居住者登録申請取得
    async getResidentUserApply(applyId: number):
        Promise<NatGetRegistrationApplyResponse> {
        return await this.http.get(`/api/admin/roomToResident/registrationApply/${applyId}`)
    }

    // 部屋居住者登録申請承認
    async putResidentUserApplyApprove(request: NatPostRegistrationApplyApproveRequest):
        Promise<NatPostRegistrationApplyApproveResponse> {
        return await this.http.put('/api/admin/roomToResident/registrationApply/approve', request)
    }

    // 部屋居住者登録申請登録
    async postResidentUserRegistrationApply(requestParams: NatPostResidentUserRegistrationApplyRequest):
        Promise<NatPostResidentUserRegistrationApplyResponse> {
        const reqParamsConvert: NatPostResidentUserRegistrationApplyRequest = requestParams
        return await this.http.post(`/api/admin/roomToResident/registrationApply`, reqParamsConvert, ContentType.JSON)
    }

    // 部屋居住者登録申請編集
    async putResidentUserRegistrationApply(requestParams: NatPutResidentUserRegistrationApplyRequest):
        Promise<NatPutResidentUserRegistrationApplyResponse> {
        return await this.http.put(`/api/admin/roomToResident/registrationApply`, requestParams)
    }

    // 部屋居住者登録申請差戻
    async putResidentUserApplyRemand(request: NatPutRegistrationApplyRemandRequest):
        Promise<NatPutRegistrationApplyRemandResponse> {
        return await this.http.put('/api/admin/roomToResident/registrationApply/remand', request)
    }

    // 部屋居住者登録申請削除
    async deleteResidentUserApply(request: NatDeleteRegistrationApplyRequest):
        Promise<NatDeleteRegistrationApplyResponse> {
        return await this.http.delete(`/api/admin/roomToResident/registrationApply/${request.applyId}`)
    }

    // 部屋居住者状況一覧取得
    async getRoomToResidentStatus(request: NatGetResidentUserStatusListRequest):
        Promise<NatGetResidentUserStatusListResponse> {
        const searchParams: string[] = []
        if (request.ridgeCd !== '') {
            searchParams.push(`ridgeCd=${encodeURIComponent(request.ridgeCd)}`)
        }
        if (request.roomNumber !== '') {
            searchParams.push(`roomNumber=${encodeURIComponent(request.roomNumber)}`)
        }
        if (request.roleId.length > 0) {
            searchParams.push(`roleId=${encodeURIComponent(request.roleId.join(','))}`)
        }
        if (request.residentUserType.length > 0) {
            searchParams.push(`residentUserType=${encodeURIComponent(request.residentUserType.join(','))}`)
        }
        if (request.assocDirectorFlag.length > 0) {
            searchParams.push(`assocDirectorFlag=${encodeURIComponent(request.assocDirectorFlag.join(','))}`)
        }
        if (request.status.length > 0) {
            searchParams.push(`status=${encodeURIComponent(request.status.join(','))}`)
        }
        if (request.assocUnassignedFlag.length > 0) {
            searchParams.push(`assocUnassignedFlag=${encodeURIComponent(request.assocUnassignedFlag.join(','))}`)
        }
        searchParams.push(`pageNum=${encodeURIComponent(request.pageNum)}`)
        searchParams.push(`page=${encodeURIComponent(request.page)}`)
        request.sortInfo.forEach((sortInfo) => {
            const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
            searchParams.push(`sortInfo=${value}`)
        })
        const searchParamsText: string = searchParams.join('&')

        return await this.http.get(`/api/admin/roomToResident/statusConfirmation?${searchParamsText}`)
    }

    // 認証キー通知状発行申請取得
    async getResidentUserAuthKeyNoticeApply(seq: number):
        Promise<NatGetResidentAuthKeyNoticeApplyResponse> {
        return await this.http.get(`/api/admin/roomToResident/noticeApply/${seq}`)
    }

    // 通知状発行（再発行）申請却下
    async putRoomToResidentNoticeApplyRejection(requestParam: NatPutResidentNoticeApplyRejectionParams):
        Promise<NatPutResidentNoticeApplyRejection> {
        return await this.http.put(`/api/admin/roomToResident/noticeApplyRejection`, requestParam)
    }
}
